// @flow
import React, { PureComponent } from 'react';
import { Select } from '../../../../components/ui/forms';

class RoomsSelect extends PureComponent {
  props: {
    value: string,
    onChange: Function,
    name: string,
  }

  render() {
    return (
      <Select
        name={this.props.name}
        onChange={this.props.onChange}
        value={this.props.value}
      >
        <option value="4">Recientes a Antiguas</option><option value="5">Antiguas a Recientes</option><option value="1">Mas consultadas</option><option value="2">Menores precios</option><option value="3">Mayores precios</option><option value="6">Areas Grandes</option><option value="7">Areas Pequeñas</option>
      </Select>
    );
  }
}

export default RoomsSelect;



// WEBPACK FOOTER //
// ./src/components/BuildingsView/FiltersBar/SortSelect/index.js